import { render, staticRenderFns } from "./NewAmparo.vue?vue&type=template&id=3da2a19e&"
import script from "./NewAmparo.vue?vue&type=script&lang=js&"
export * from "./NewAmparo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports